import { UserSettingsService } from 'app/user/user-settings.service';
var OrderSettingsComponent = /** @class */ (function () {
    function OrderSettingsComponent(_userSettingsService) {
        this._userSettingsService = _userSettingsService;
    }
    Object.defineProperty(OrderSettingsComponent.prototype, "showRegion", {
        get: function () {
            return this._userSettingsService.serviceType === 'ic';
        },
        enumerable: true,
        configurable: true
    });
    return OrderSettingsComponent;
}());
export { OrderSettingsComponent };
